import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogBaseContainerComponent } from '../dialog-base-container/dialog-base-container.component';
import { PortalModule } from '@angular/cdk/portal';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { DialogCloseDirective } from '../../directives/dialog-close.directive';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';

@Component({
  templateUrl: './dialog-default-container.component.html',
  styleUrls: ['./dialog-default-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('state', [
      state('void, exit', style({ opacity: 0, transform: `translateY(50px)` })),
      transition(':enter', animate('250ms cubic-bezier(0, 0, 0.2, 1)', style({ transform: 'none', opacity: 1 }))),
      transition(':leave', animate('75ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ opacity: 0 }))),
    ]),
  ],
  standalone: true,
  imports: [NgIf, MatButtonModule, DialogCloseDirective, SvgIconComponent, PortalModule],
})
export class DialogDefaultContainerComponent extends DialogBaseContainerComponent {}
